import React, { useCallback } from 'react'

import { MenuSelectorField, SingleOptionSelectorField, ModelMenuSelectorField, DateTimeCompactField } from '@front/squirtle'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'

const Row = ({ row }) => {
  const { active, authorized_model } = row || {}

  return (
    <>
      <TableCell size={'small'}>
        <SingleOptionSelectorField
          name={'active'}
          optionLabel={active ? I18n.t('status.active') : I18n.t('status.inactive')}
          clearOnEmpty={false}
        />
      </TableCell>
      <TableCell size={'small'}>
        <MenuSelectorField
          name='authorized_model'
          options={[
            { label: I18n.t('order.label.alter_plural'), value: 'order' },
            { label: `${I18n.t('contract.label', { count: 1 })} / ${I18n.t('companyservice.label', { count: 2 })}`, value: 'companycontract' },
            { label: I18n.t('companyuser.label', { count: 2 }), value: 'companyuser' },
          ]}
          required
          selectFirst={false}
        />
      </TableCell>
      <TableCell size={'small'}>
        <ModelMenuSelectorField
          name={'template'}
          model_name='template'
          searchMode='search'
          labelKeys={['name_translated']}
          allowNone={false}
          selectFirst={false}
          config={{
            populate: ['name_trkey'],
            initial_filter: { model: authorized_model },
            forced_filter: { model: authorized_model },
            validate_filter: useCallback(() => !!authorized_model, [authorized_model]),
            watchers: [authorized_model],
          }}
          required
        />
      </TableCell>
      <TableCell size={'small'}>
        <DateTimeCompactField
          name={'export_start_date'}
          inputFormat={'DD/MM/YYYY HH:mm'}
        />
      </TableCell>
    </>
  )
}
export default React.memo(Row)
